/**
 * GET/POST/PUT/PATCH/DELETE helpers for the CRM backend, with the same
 * signatures as services/controller.services.js (which targets Identity
 * Center). Screens whose data lives in the CRM import from here instead.
 */
import { toast } from 'react-toastify';
import crmAxios from '@/api/crmAxios';

const request = async (method, url, { params = {}, payload } = {}) => {
  const response = await crmAxios.request({
    url,
    method: method.toUpperCase(),
    params,
    data: payload,
  });
  if (method !== 'GET' && response.data?.message) {
    toast.success(response.data.message);
  }
  return response;
};

export const GET = (path, params = {}) => request('GET', path, { params });
export const POST = (path, payload = {}) => request('POST', path, { payload });
export const PUT = (path, payload = {}) => request('PUT', path, { payload });
export const PATCH = (path, payload = {}) => request('PATCH', path, { payload });
export const DELETE = (path) => request('DELETE', path);

// ─── Customer reviews (CRM: /api/superadmin/reviews/) ─────────────────────────
export const getReviews = (params = '') => crmAxios.get(`/api/superadmin/reviews/${params}`);
export const getReviewStats = () => crmAxios.get('/api/superadmin/reviews/stats/');
export const approveReview = (id) => crmAxios.post(`/api/superadmin/reviews/${id}/approve/`);
export const rejectReview = (id) => crmAxios.post(`/api/superadmin/reviews/${id}/reject/`);
export const toggleReviewFeatured = (id) => crmAxios.post(`/api/superadmin/reviews/${id}/toggle_featured/`);
export const createReview = (data) => crmAxios.post('/api/superadmin/reviews/', data);
export const updateReview = (id, data) => crmAxios.put(`/api/superadmin/reviews/${id}/`, data);
export const deleteReview = (id) => crmAxios.delete(`/api/superadmin/reviews/${id}/`);

// ─── CRM health / access check ───────────────────────────────────────────────
// 200 = this console login works on the CRM backend as a superadmin.
export const checkCrmAccess = () => crmAxios.get('/api/superadmin/reviews/stats/');
